// extracted by mini-css-extract-plugin
export default {"logo":"Banner_logo__GI7oF","header_style":"Banner_header_style__5uB8j","subtitle_style":"Banner_subtitle_style__nEHeH","toggleThemeButton":"Banner_toggleThemeButton__d4fix"};